module.exports = __webpack_public_path__ + "static/media/sbt.97fd1e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/sbt.png
// module id = 1504
// module chunks = 0